export function selectItems() {
  return (state) => state.items.current.items;
}